export default __webpack_public_path__ + "static/media/ISSO CLASS-8_SYLLABUS_2025-26.951eb1d8.pdf";